import React, { useState, useEffect, useRef, } from 'react'
import { useLocation } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha';
import HtmlParser from 'react-html-parser';

import useAuth from '../../auth/useAuth';

import {
    settings, validateEmail, settingsPassword, isUndNullEmpNew, getError, getLanguageObj, getResponse, sendMessageCloseCurrentWindow,
    LoadingSection, awaitDelay
} from '../../helpers/UtilsHelper';
import Menu from '../main/Menu';
import { LoginClass } from '../../classes/auth/loginClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { app, icons, images, firebase, messages, labels } = settings;
const { urls } = app?.backend;
const { fields: dbFields, } = firebase?.firestore;

const currentMethod = 'Login - function';

export default function Login({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const location = useLocation();
    const chkRemenberMeId = 'chkRemenberMe';
    const locationStateFrom = location.state?.from;
    const localStorageRedirectUrl = localStorage.getItem(settings.localStorage.redirectId);
    let previusObjUrl = !isUndNullEmpNew({
        data: locationStateFrom,
        subMethod: 'Login - checkPreviusState'
    })?.result ? locationStateFrom : null;

    if (!previusObjUrl && !isUndNullEmpNew({
        data: localStorageRedirectUrl,
        subMethod: 'Login - checkPreviusLocalStorage'
    })?.result) {
        previusObjUrl = localStorageRedirectUrl;
    }

    const [formData, setFormData] = useState(LoginClass?.getClass());
    const [errors, setErrors] = useState({ email: '', password: '' });
    const [process, setProcess] = useState({ showLoading: false, login: false, home: false });
    const [showPassword, setShowPassword] = useState(false);
    const isMount = useRef(true);
    // const [currentTheme, setCurrentTheme] = useState(document?.documentElement?.getAttribute('data-theme') || 'light');
    const reCaptchaRef = useRef(ReCAPTCHA);

    //#region old code
    // const controls = {
    //     buttons: {
    //         home: {
    //             defaultClass: 'btn btn-light border shadow-sm font-weight-bold text-secondary mx-1 px-4',
    //             id: 'btnHome',
    //             style: { borderRadius: '8px' }
    //         },
    //         login: {
    //             defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
    //             id: 'btnLogin',
    //             style: { borderRadius: '8px' }
    //         },
    //     },
    //     icons: {
    //         home: {
    //             id: 'iconLogin',
    //             defaultClass: icons?.fasFa?.home,
    //         },
    //         login: {
    //             id: 'iconLogin',
    //             defaultClass: icons?.fasFa?.powerOff,
    //         },
    //     },
    //     spiners: {
    //         home: {
    //             id: 'spLogin',
    //             defaultClass: '',
    //         },
    //         login: {
    //             id: 'spLogin',
    //             defaultClass: '',
    //         }
    //     },
    // };
    //#endregion old code
    //#endregion variables

    //#region methods
    const formDataValidate = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataValidate';
        let response = getResponse({ type: 0 });
        try {
            const thisFieldRequired = messages?.thisFieldRequired?.[languageObj?.id];
            const errors_ = { email: '', password: '' };

            if (isUndNullEmpNew({ data: formData?.email, subMethod: currentMethod })?.result) {
                errors_.email = thisFieldRequired;
                response = getResponse({ type: 1 });
            } else if (!validateEmail(formData.email)) {
                errors_.email = messages?.youMustEnterValidEmail?.[languageObj?.id];
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: formData?.password, subMethod: currentMethod, })?.result) {
                errors_.password = thisFieldRequired;
                response = getResponse({ type: 1 });
            } else if (formData?.password?.trim()?.length < settingsPassword?.maxLength) {
                errors_.password = messages?.youMustEnterValidPassword?.[languageObj?.id];
                response = getResponse({ type: 1 });
            }

            setErrors(prev => ({ ...prev, email: errors_?.email, password: errors_?.password }));
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const login = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'login';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();

            //#region form validate
            response = formDataValidate({
                subMethod: currentMethod
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion form validate

            setShowPassword(false);

            //#region login
            setProcess(prev => ({ ...prev, showLoading: true, login: true }));

            const reCaptchaTokenLocal = await reCaptchaRef.current.executeAsync();
            reCaptchaRef.current.reset();

            const data = {
                email: formData?.email,
                password: formData?.password,
                rememberMe: formData?.rememberMe,
                accountDataSave: true,
                reCaptchaToken: reCaptchaTokenLocal,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            };
            response = await auth.login({ ...data });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion Login
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, login: false }));

            if (response?.isSuccess && !response?.isWarning) {
                localStorage.removeItem(settings.localStorage.redirectId);
                window.location.href = previusObjUrl || urls?.home;
            }

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            // setFormData(LoginClass?.getClass());
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const gotoHome = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'gotoHome';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault();
            setProcess(prev => ({ ...prev, showLoading: true, home: true }));
            await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
            window.location.href = urls?.home;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false, home: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    //#region old code
    // useEffect(() => {
    //     const observer = new MutationObserver((mutations) => {
    //         mutations.forEach((mutation) => {
    //             if (mutation?.type === 'attributes' && mutation?.attributeName === 'data-theme') {
    //                 setCurrentTheme(document?.documentElement?.getAttribute('data-theme'));
    //             }
    //         })
    //     });

    //     observer?.observe(document?.documentElement, {
    //         attributes: true,
    //         attributeFilter: ['data-theme']
    //     });

    //     return () => {
    //         observer?.disconnect();
    //     }
    // }, [currentTheme]);
    //#endregion old code

    //#region old code
    // useEffect(() => {
    //     return () => {
    //         // Al cambiar de tema, eliminamos los badges anteriores del reCAPTCHA inyectados en el body
    //         const badges = document.querySelectorAll('.grecaptcha-badge');
    //         badges.forEach(badge => badge.remove());
    //     }
    // }, [currentTheme]);
    //#endregion old code
    //#endregion methods

    return (
        <div>
            <Menu viewName={'home'} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.login?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.login?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>

                                <div className='login-box login-box-container'>

                                    <div className={settings?.html?.cards?.default} >
                                        <LoadingSection alt='loadingSection'
                                            className='overlay dark text-white'
                                            height={20}
                                            hidden={!process?.showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        {/* ✅ Premium Card Header (Rule 12) */}
                                        <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                            <div className='d-flex align-items-center'>
                                                <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                    style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <img alt='UserLogin'
                                                        style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                        src={images?.userLogin} />
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <h5 className='mb-0 font-weight-bold text-dark'>{labels?.login?.[languageObj?.id]}</h5>
                                                    <div className='mt-1'>
                                                        <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                            <i className={`${icons?.fasFa?.key} mr-1`}></i> {labels?.authentication?.[languageObj?.id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <p className='text-muted small mt-3 mb-0'>{labels?.signInToStartYourSession?.[languageObj?.id]}</p> */}
                                        </div>

                                        <form onSubmit={(e) => login({ e: e, subMethod: 'form - onSubmit', })} method='post'>

                                            {/* Body with wide spacing */}
                                            <div className='card-body px-4 pt-2'>

                                                <div className='form-group mb-4'>
                                                    <label className='small font-weight-bold text-uppercase form-label-uppercase'>{labels?.email?.[languageObj?.id]}</label>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.envelope} position-absolute input-icon-left`} />
                                                        <input autoFocus
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            onChange={(e) => setFormData(prev => ({ ...prev, [dbFields?.email]: e?.target?.value }))}
                                                            onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                            value={formData?.email || ''}
                                                            placeholder={labels?.emailPlaceholder?.[languageObj?.id]}
                                                            autoComplete='email'
                                                            title={labels?.email?.[languageObj?.id]} />
                                                    </div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.email)}</div>
                                                </div>

                                                <div className='form-group mb-3'>
                                                    <div className='d-flex justify-content-between align-items-center mb-1'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase'>{labels?.password?.[languageObj?.id]}</label>
                                                        {/* <a href='/forgotPassword' style={{ fontSize: '12px', color: '#6366f1', fontWeight: '600' }}>{labels?.forgotYourPassword?.[languageObj?.id]}</a> */}
                                                    </div>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.lock} position-absolute input-icon-left`} />
                                                        <input onChange={(e) => setFormData(prev => ({ ...prev, [dbFields?.password]: e?.target?.value, }))}
                                                            onFocus={() => setErrors(prev => ({ ...prev, password: '' }))}
                                                            value={formData?.password || ''}
                                                            type={showPassword ? 'text' : 'password'}
                                                            className='form-control border-0 shadow-sm form-input-icon-both'
                                                            autoComplete='current-password'
                                                            placeholder='••••••••' />
                                                        <span className='position-absolute input-icon-right'
                                                            onClick={(e) => setShowPassword(!showPassword)}>
                                                            <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                        </span>
                                                    </div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.password)}</div>
                                                </div>

                                                <div className='custom-control custom-checkbox mb-4'>
                                                    <input id={chkRemenberMeId}
                                                        type='checkbox'
                                                        className='custom-control-input'
                                                        onChange={(e) => setFormData(prev => ({ ...prev, rememberMe: e?.target?.checked, }))} />
                                                    <label className='custom-control-label text-muted' htmlFor={chkRemenberMeId} style={{ cursor: 'pointer' }}>
                                                        {labels?.rememberMe?.[languageObj?.id]}
                                                    </label>
                                                </div>

                                                <div className='d-flex justify-content-end align-items-right mb-0'>
                                                    <a href='/forgotPassword' className='link-primary-bold'>{labels?.forgotYourPassword?.[languageObj?.id]}</a>
                                                </div>

                                            </div>

                                            {/* Clean footer */}
                                            <div className='card-footer border-0 bg-white px-4 pb-4'>
                                                <button data-title={labels?.login?.[languageObj?.id]}
                                                    type='submit'
                                                    disabled={process?.showLoading}
                                                    className='btn btn-primary btn-block shadow-sm font-weight-bold btn-primary'>
                                                    {!process?.login ? (
                                                        <i className={icons?.fasFa?.powerOff} />
                                                    ) : (
                                                        <span className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                    )} {labels?.signIn[languageObj?.id]}
                                                </button>

                                                <button data-title={labels?.home?.[languageObj?.id]}
                                                    type='button'
                                                    onClick={(e) => gotoHome({ e: e, subMethod: 'form - btnHome' })}
                                                    //className='btn btn-primary btn-block shadow-sm font-weight-bold mt-2'
                                                    className='btn btn-light border btn-block mt-2 shadow-sm font-weight-bold text-secondary btn-general'>
                                                    <i className={icons?.fasFa?.home} /> {labels?.home[languageObj?.id]}
                                                </button>
                                            </div>

                                        </form>

                                        <div className='px-4 pb-4 text-center border-top pt-3 login-register-section'>
                                            <p className='small text-muted mb-2'>{labels?.registerNewMembership?.[languageObj?.id]}</p>
                                            <div className='d-flex justify-content-center gap-2 flex-wrap'>
                                                {/* <a href='/registerNewUser' className='btn btn-outline-light btn-sm border text-dark mx-1 btn-register-link'> */}
                                                <a href='/registerNewUser' data-title={labels?.createAccount?.[languageObj?.id]} className='btn btn-light border shadow-sm  mx-1 font-weight-bold text-secondary'>
                                                    <i className={`${icons?.fasFa?.userCheck} mr-1 text-primary`} /> {labels?.createAccount?.[languageObj?.id]}
                                                </a>
                                                {/* <a href='/registerStatus' className='btn btn-outline-light btn-sm border text-dark mx-1 btn-register-link'> */}
                                                <a href='/registerStatus' data-title={labels?.myStatus?.[languageObj?.id]} className='btn btn-light border shadow-sm mx-1 font-weight-bold text-secondary'>
                                                    <i className={`${icons?.userClock} mr-1 text-warning`} /> {labels?.myStatus?.[languageObj?.id]}
                                                </a>
                                            </div>
                                        </div>

                                        {/* <div style={{ display: 'g-recaptcha' }}> */}
                                        <ReCAPTCHA className='g-recaptcha'
                                            sitekey={settings?.app?.reCAPTCHA?.reCaptchaSiteKey}
                                            // theme={currentTheme}
                                            size='invisible'
                                            hl={languageObj?.id}
                                            ref={reCaptchaRef} />
                                        {/* </div> */}
                                    </div>
                                </div>

                                <div className='text-muted text-center text-small mt-4'>
                                    <p className='recaptcha-notice'>
                                        {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank'
                                            href={settings?.app?.reCAPTCHA?.urlPrivaciConditions}
                                            className='link-primary'
                                            rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                        </a>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
        </div>
    )
}